import { SnomedSearch } from "components/search";

const SnomedCTPage = () => {
  return <SnomedSearch />;
};

export default SnomedCTPage;
